import { useState, useCallback } from 'react';
import { Order, OrderSummary } from '../../types/order';
import { UserOrderStats, defaultUserOrderStats } from './UserOrderTypes';

/**
 * User Order State Management Hook
 * Handles core state for user orders (data, loading, errors)
 */

export const useUserOrderState = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [ordersSummary, setOrdersSummary] = useState<OrderSummary[]>([]);
  const [stats, setStats] = useState<UserOrderStats>(defaultUserOrderStats);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    orders,
    setOrders,
    ordersSummary,
    setOrdersSummary,
    stats,
    setStats,
    loading,
    setLoading,
    error,
    setError,
    clearError,
  };
};
